module.exports = __webpack_public_path__ + "static/img/v8.86d4045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v8.jpg
// module id = yYwJ
// module chunks = 1